window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
import { createPopper } from '@popperjs/core';
import Alpine from 'alpinejs';

window.Alpine = Alpine;
Alpine.start();

window.popper = createPopper;

window.toggle_profile = function () {
    window.dispatchEvent(new CustomEvent('profile', { bubbles: true }));
}

document.addEventListener('DOMContentLoaded', () => {
    let timeout;
    let last = window.scrollY;
    let header = document.querySelector('header#header');
    let home = header.classList.contains('home');
    document.addEventListener('scroll', e => {
        timeout = setTimeout(() => {
            clearTimeout(timeout);
            let y = window.scrollY;
            if (y > 0) {
                header.classList.add('scroll');
            } else {
                header.classList.remove('scroll');
            }
            if (home) {
                if (y > 0) {
                    header.classList.remove('moved');
                } else {
                    header.classList.add('moved');
                }
            }
            if (window.innerWidth < 640) {
                if (y < last || y < 109) {
                    header.classList.remove('hidden');
                } else if (y > last && y >= 109) {
                    header.classList.add('hidden');
                }
            }
            last = y;
        }, 50);
    });
    window.addEventListener('resize', e => {
        if (window.innerWidth >= 640) {
            header.classList.remove('hidden');
        }
    });
})
